import { render, staticRenderFns } from "./KundenListField.vue?vue&type=template&id=7faa838e&"
import script from "./KundenListField.vue?vue&type=script&lang=js&"
export * from "./KundenListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports